module.exports = __webpack_public_path__ + "4dd9ec493bad5eee1d5ad75fadb050a2.png";